import { render } from "./DashboardEditCoupon.vue?vue&type=template&id=37ee9730&scoped=true"
import script from "./DashboardEditCoupon.vue?vue&type=script&lang=js"
export * from "./DashboardEditCoupon.vue?vue&type=script&lang=js"

import "./DashboardEditCoupon.vue?vue&type=style&index=0&id=37ee9730&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ee9730"]])

export default __exports__